export const screenerIntroSteps = [
  {
    element: '#help-tour-btn',
    intro: 'Click here to take a tour of this page.'
  },
  {
    element: '#resources-title',
    intro: 'Screener is where you can find overview information and frequently asked questions about the WordFlight Screener.'
  },
  {
    element: '.kb-list:first-child wf-knowledge-base-item:first-child',
    intro: 'Click here to view the WordFlight Screener welcome information. It provides you with all the information you need to get started with using the WordFlight Screener.'
  },
  {
    element: '.kb-list:last-child wf-knowledge-base-item:first-child',
    intro: 'Click here to view the frequently asked questions about the WordFlight Screener. Contact your WordFlight Partner Success and Professional Learning Specialist or the WordFlight Customer Support Team if you have any additional questions.'
  },
  {
    element: '.kb-list:last-child wf-knowledge-base-item:last-child',
    intro: 'Click here to view a video that provides an overview of the WordFlight Screener.'
  }
];
